import React from 'react'
import { Dialog } from 'primereact/dialog'

// valores aceitos pela API (SituacaoFiltroLancamentosIndividuaisComrpasEnum)
export const situacaoTodasAsNotas = 'TODAS'
export const situacaoApenasNotasValidadas = 'APENAS_NOTAS_VALIDADAS'

const opcoesDeSituacao = [
    {
        valor: situacaoTodasAsNotas,
        icone: 'pi pi-copy',
        titulo: 'Todas as notas',
        descricao: 'Inclui todas as notas do período, validadas ou não.',
    },
    {
        valor: situacaoApenasNotasValidadas,
        icone: 'pi pi-check-circle',
        titulo: 'Apenas notas validadas',
        descricao: 'Considera somente as notas que já foram validadas.',
    },
]

// dialog simples: pergunta se o usuário quer todas as notas ou só as validadas
class EscolhaSituacaoNotasDialog extends React.Component {

    state = {
        valorDaOpcaoComMouseEmCima: null,
    }

    escolherOpcao = (valorDaSituacaoEscolhida) => {
        this.setState({valorDaOpcaoComMouseEmCima: null})
        this.props.onEscolher(valorDaSituacaoEscolhida)
    }

    fecharDialog = () => {
        this.setState({valorDaOpcaoComMouseEmCima: null})
        this.props.hideDialog()
    }

    render(){

        const renderCartaoDeOpcao = (opcao) => {
            const estaComMouseEmCima = this.state.valorDaOpcaoComMouseEmCima === opcao.valor
            return (
                <div
                    key={opcao.valor}
                    role="button"
                    tabIndex={0}
                    onClick={() => this.escolherOpcao(opcao.valor)}
                    onKeyDown={event => { if(event.key === 'Enter' || event.key === ' ') this.escolherOpcao(opcao.valor) }}
                    onMouseEnter={() => this.setState({valorDaOpcaoComMouseEmCima: opcao.valor})}
                    onMouseLeave={() => this.setState({valorDaOpcaoComMouseEmCima: null})}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '14px',
                        padding: '14px 16px',
                        marginBottom: '10px',
                        borderRadius: '10px',
                        border: `1px solid ${estaComMouseEmCima ? '#2c4670' : '#e4e4e7'}`,
                        background: estaComMouseEmCima ? '#f4f6fa' : '#fafafa',
                        cursor: 'pointer',
                        transition: 'border-color 0.15s, background 0.15s',
                    }}
                >
                    <div style={{
                        width: '40px', height: '40px', minWidth: '40px',
                        borderRadius: '8px',
                        background: '#f4f4f5',
                        border: '1px solid #e4e4e7',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: '#2c4670',
                    }}>
                        <i className={opcao.icone} style={{fontSize: '1.1rem'}} />
                    </div>
                    <div style={{flex: 1}}>
                        <div style={{fontWeight: 600, fontSize: '0.9rem', color: '#09090b', letterSpacing: '-0.01em'}}>
                            {opcao.titulo}
                        </div>
                        <div style={{fontSize: '0.8rem', color: '#71717a'}}>
                            {opcao.descricao}
                        </div>
                    </div>
                    <i
                        className="pi pi-arrow-right"
                        style={{
                            color: '#2c4670',
                            transition: 'transform 0.15s',
                            transform: estaComMouseEmCima ? 'translateX(4px)' : 'none',
                        }}
                    />
                </div>
            )
        }

        return (
            <Dialog
                visible={this.props.visible}
                header={this.props.header || "Quais notas deseja considerar?"}
                modal
                style={{ width: '480px' }}
                onHide={this.fecharDialog}
            >
                {opcoesDeSituacao.map(opcao => renderCartaoDeOpcao(opcao))}
            </Dialog>
        )
    }

}

export default EscolhaSituacaoNotasDialog
